// Steps for homepage
const homepageSteps = [
{
    element: "#sidebar",
    popover: {
        className: 'first-step-popover-class',
        title: '👋<br>Hello, welcome to Onboardio! ',
        description: 'The wizard takes no more than 10 minutes and you can come back any time by clicking on the Onboardio ship in the right corner<br>',
        nextBtnText: 'Run wizard',
        position: 'right-center',
        showButtons: true,         // Do not show control buttons in footer
    },
},
// {
//     element: "#start-guide",
//     popover: {
//         title: ' ',
//         description: 'By clicking on this icon you can restart the wizard any time.',
//         position: 'top',
//         showButtons: true,
//     },
// },
{
    element: "#guide-step-hp-1",
    popover: {
        className: 'first-step-popover-class',
        title: 'Why Onboardio?',
        description: "1.&nbsp;&nbsp;We help to find the <b>most talented people</b><br><br>2.&nbsp;&nbsp;We facilitate communication with candidates<br><br>3.&nbsp;&nbsp;<b>We reduce employee turnover</b> thanks to<br>&nbsp;&nbsp; personal pages that helps your employees to get on board<br><br>4.&nbsp;&nbsp;Thanks to custom task checklists<br>&nbsp;&nbsp;<b>you don't forget important things anymore...</b>",
        position: 'bottom',
        showButtons: true,
    },
    onNext: () => {
        $('#hiring.collapse').collapse('show');

    }
},
{
    element: "#sidebar",
    popover: {
        className: 'first-step-popover-class',
        title: ' ',
        description: 'Discover how <b>make recruitment easier</b> with our integrated management of jobs and ads (1 min)',
        position: 'right',
        doneBtnText: 'Yes, carry on',
        showButtons: true,
    },
    onNext: () => {
        // Prevent moving to the next step
        window.location.assign("/jobs#guide");

    }
},
]



export default homepageSteps
